<template>
  <div id="app">
    <table>
      <tr>
        <td rowspan="2" style="vertical-align: bottom; max-width: 680px; width: 90%; padding: 0 15px 0 15px">
          <div style="width: 700px;">
            <router-link to="/">
            <img alt="logo" src="./assets/logo.jpg">
            </router-link>
          </div>
        </td>
        <td>
          <router-link to="/embdProjectDescription">
          <p class="project-title text-center">Embryonic Development</p>
          </router-link>
        </td>
        <td>
          <router-link to="/eecdProjectDescription">
          <p class="project-title text-center">Early Embryonic Cell Division</p>
          </router-link>
        </td>
        <td>
          <router-link to="/gmProjectDescription">
          <p class="project-title text-center">Germline Morphology</p>
          </router-link>
        </td>
      </tr>
      <tr>
        <td class="top-td">
          <div style="width: 140px">
            <router-link to="/embdProjectDescription">
              <img class="img-top" src="~@/assets/embd-card.png" alt="Embryonic Development Title Image">
            </router-link>
          </div>
        </td>
        <td class="top-td">
          <div style="width: 140px">
            <router-link to="/eecdProjectDescription">
              <img class="img-top" src="~@/assets/eecd-card.png" alt="Early Embryonic Cell Division Title Image">
            </router-link>
          </div>
        </td>
        <td class="top-td"  style="padding: 0 15px 0 0">
          <div style="width: 140px">
            <router-link to="/gmProjectDescription">
              <img class="img-top" src="~@/assets/gm-card.png" alt="Germline Morphology Title Image">
            </router-link>
          </div>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>
          <router-link to="/embdProjectDescription">
          <p class="project-reference text-center">Green, Khaliullin et al., 2024</p>
          </router-link>
        </td>
        <td>
          <router-link to="/eecdProjectDescription">
          <p class="project-reference text-center">Sonnichsen et al., 2005</p>
          </router-link>
        </td>
        <td>
          <router-link to="/gmProjectDescription">
          <p class="project-reference text-center">Green et al., 2011</p>
          </router-link>
        </td>
      </tr>
    </table>
    <router-view></router-view>

    <footers />
  </div>
</template>

<script>
import Footers from '@/components/Footers.vue';
export default {
  name: 'PhenoBank',
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Home',
    // all titles will be injected into this template
    titleTemplate: '%s | PhenoBank'
  },
  components: {
    // Links,
    Footers,
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 10px;
}

.img-top {
  height: 80px;
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
  display: block; margin: auto;
  vertical-align: bottom;
}

p.project-title {
  color: #2f5597;
  font-style: oblique;
  font-weight: bold;
  font-size: 10px;
  margin-bottom: 0;
}

p.project-reference {
  color: #2f5597;
  font-style: oblique;
  font-weight: normal;
  font-size: 9px;
  margin-bottom: 0;
}

.top-td {
  padding-right: 5px;

}
</style>
